import React from 'react';
import StatusWidgetSettings from '../../../WidgetEditionPage/WidgetSettings/StatusWidgetSettings';

const etaSupportLink =
  'https://support.portal.sevensenders.com/support/solutions/articles/15000010426-designing-and-publishing-a-tracking-page#ETA';

const TrackingPageStatusWidgetSettings = (props) => <StatusWidgetSettings etaSupportLink={etaSupportLink} {...props} />;

export default TrackingPageStatusWidgetSettings;
